export const INTERVIEW_STATUS = [
  { id: 1, value: 'accepted' },
  { id: 2, value: 'rejected' },
];
